import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LogIn, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import Logo from "../components/Logo";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      toast.success("Welcome back");
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen bg-navy-950 text-white flex items-center justify-center px-4 relative overflow-hidden" data-testid="page-admin-login">
      <div className="absolute inset-0 bg-arch-dark" aria-hidden="true" />
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[600px] h-[400px] rounded-full bg-royal/20 blur-[120px]" aria-hidden="true" />
      <div className="relative w-full max-w-md">
        <div className="flex justify-center mb-8"><Logo dark /></div>
        <form onSubmit={onSubmit} className="rounded-3xl bg-white/[0.06] border border-white/10 backdrop-blur p-8" data-testid="admin-login-form">
          <h1 className="font-display font-extrabold tracking-tight text-2xl">Leads Dashboard</h1>
          <p className="mt-2 text-sm text-ice/60">Sign in to review savings inquiries.</p>
          <div className="mt-6 space-y-4">
            <div>
              <label htmlFor="admin-email" className="block text-xs font-bold uppercase tracking-wider2 text-teal-bright mb-1.5">Email</label>
              <input id="admin-email" data-testid="admin-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full rounded-xl border border-white/15 bg-navy-900/60 px-4 py-3 text-white placeholder:text-ice/30 focus:outline-none focus:ring-2 focus:ring-teal" placeholder="admin@yourbusiness.com" />
            </div>
            <div>
              <label htmlFor="admin-password" className="block text-xs font-bold uppercase tracking-wider2 text-teal-bright mb-1.5">Password</label>
              <input id="admin-password" data-testid="admin-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full rounded-xl border border-white/15 bg-navy-900/60 px-4 py-3 text-white placeholder:text-ice/30 focus:outline-none focus:ring-2 focus:ring-teal" placeholder="••••••••" />
            </div>
          </div>
          {error && <p className="mt-4 text-sm font-semibold text-red-300" data-testid="admin-login-error" role="alert">{error}</p>}
          <button type="submit" data-testid="admin-login-submit" disabled={busy} className="group mt-6 w-full inline-flex items-center justify-center gap-2 bg-teal text-navy font-bold px-6 py-3.5 rounded-xl transition-all duration-300 hover:bg-teal-bright disabled:opacity-60">
            <LogIn className="w-4 h-4" />
            {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <div className="mt-6 text-center">
          <Link to="/" data-testid="admin-back-home" className="inline-flex items-center gap-2 text-sm text-ice/60 hover:text-teal-bright transition-colors">
            <ArrowLeft className="w-4 h-4" /> Back to website
          </Link>
        </div>
      </div>
    </main>
  );
}
